/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type mcqAnswers = {
    quizTitle:string;
    studentAnswers:{    
        score:number;
        status:string;
        num_tries:number
    }[]
};
type essayAnswers = {
    quizTitle:string;
    quizDetails:{    
        score:number;
        status:string;
        num_tries:number
        question:{
            question:string;
            explanation:string;
        }[]
    }[]
};

export type AnswersDTO = {
    mcqResponse: mcqAnswers;
    essayResponse: essayAnswers;
};

type GetAnswersResponse = {
    statusCode?: number;
    error?: ApiError | null;
    data?: AnswersDTO;
};

export const GetExamAnswers = async (quizId: string): Promise<GetAnswersResponse> => {
    try {
        const response = await axios.get(`/student-submit/studentAnswersExam/${quizId}`);
            return { data: response.data };
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};